import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from 'components/Layout/Card';
import Button from 'components/form/Button';
import Dropdown from 'components/form/Dropdown';
import {
  checkEmailVerification,
  getDataFromLocalStorage,
  trimLeftSpace,
  VERIFICATION_STEPS,
} from 'utils/helpers';
import QuestionDetails from './QuestionDetails';
import NewPostDetails from './NewPostDetails';
import './CreatePost.scss';
import { useNavigate } from 'react-router-dom';
import TextInput from 'components/form/TextInput';

const CreatePost = ({
  type,
  label = 'Create Your Research Post',
  successParent,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { postCategoryList } = useSelector((state) => ({
    postCategoryList: state.global.postCategoryList,
  }));
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));
  const [postCategory, setPostCategory] = useState('');
  const [postTitle, setPostTitle] = useState('');
  const [isNext, setIsNext] = useState(false);
  const [isQuestion, setIsQuestion] = useState(false);

  // const {
  //   view: viewAccess,
  //   create: createAccess,
  //   update: updateAccess,
  //   delete: deleteAccess,
  // } = userDetails?.role_data?.find((item) =>
  //   ['Network Management', 'My Post and Networks'].includes(
  //     item?.permission_name
  //   )
  // )?.sub_permission || {};

  const permissions = userDetails?.role_data?.filter((item) =>
    ['Network Management', 'My Post and Networks'].includes(
      item?.permission_name
    )
  );

  let userData = getDataFromLocalStorage();
  let { user_type } = userData;

  const createAccess = ['0', '1', '6', '7'].includes(user_type)
    ? permissions?.some((perm) => perm?.sub_permission?.create === '1')
      ? '1'
      : '0'
    : '1';

  return (
    <>
      <Card className={`${type ? 'cps-24 cpe-24' : 'mt-3 cps-24 cpe-24 cpt-24 cpb-10'}`}>
        {isNext && (
          <>
            {/* <PostDetails
            type={type}
            postCategory={postCategory}
            postTitle={postTitle}
            onHide={() => {
              setIsNext(false);
              setPostCategory("");
              setPostTitle("");
            }}
            handelSuccess={() => {
              setIsNext(false);
              setPostCategory("");
              setPostTitle("");
              if (successParent) {
                successParent();
              }
            }}
          /> */}
            <NewPostDetails
              type={type}
              postCategory={postCategory}
              postTitle={postTitle}
              onHide={() => {
                setIsNext(false);
                setPostCategory('');
                setPostTitle('');
              }}
              handelSuccess={() => {
                setIsNext(false);
                setPostCategory('');
                setPostTitle('');
                if (successParent) {
                  successParent();
                }
              }}
            />
          </>
        )}
        {isQuestion && (
          <QuestionDetails
            postTitle={postTitle}
            onHide={() => {
              setIsQuestion(false);
              setPostCategory('');
              setPostTitle('');
            }}
            handelSuccess={() => {
              setIsQuestion(false);
              setPostCategory('');
              setPostTitle('');
              if (successParent) {
                successParent();
              }
            }}
          />
        )}

        {type ? <>
          <div
            className="d-flex justify-content-between align-items-center cmb-16 w-fit"
            id="create-new-post-id"
          >
            <div className="text-18-500-27 color-title-navy font-poppins">
              {label}
            </div>
          </div>
          <div className="row g-3 mb-3 align-items-center">
            <div className="col-12 col-md-4 col-lg-4">
              <Dropdown
                id="eventid"
                placeholder="Select post category*"
                value={postCategory}
                options={postCategoryList}
                optionValue="name"
                onChange={(e) => setPostCategory(e.target.value)}
                className="small-dropdown w-100"
              />
            </div>

            <div className="col-12 col-md-6 col-lg-7 post-input-container">
              <TextInput
                placeholder="Post Title*"
                id="post-input"
                value={postTitle}
                onChange={(e) => setPostTitle(trimLeftSpace(e.target.value))}
                className="h-35 text-14-300 w-100"
              />
            </div>

            <div className="col-12 col-md-2 col-lg-1 text-md-end">
              {createAccess === '1' && (
                <Button
                  className="h-35 w-100 w-md-auto"
                  btnStyle="primary-dark"
                  icon={<i className="bi bi-send" />}
                  disabled={!postCategory || !postTitle}
                  onClick={() => {
                    if (!checkEmailVerification(dispatch, navigate, VERIFICATION_STEPS.PROFILE_ONLY)) return;
                    if (postCategory === 8) {
                      setIsQuestion(true);
                    } else {
                      setIsNext(true);
                    }
                  }}
                />
              )}
            </div>
          </div>
        </> :
          <>
            <div
              className="d-flex justify-content-between align-items-center mb-3 w-fit"
              id="create-new-post-id"
            >
              <div className="text-18-500-27 color-title-navy font-poppins">
                {label}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 mb-3">
                <Dropdown
                  id="eventid"
                  placeholder="Select post category*"
                  value={postCategory}
                  options={postCategoryList}
                  optionValue="name"
                  onChange={(e) => {
                    setPostCategory(e.target.value);
                  }}
                />
              </div>
              <div className="col-md-8 mb-3 post-input-container">
                <input
                  id="post-input"
                  placeholder="Post Title*"
                  value={postTitle}
                  onChange={(e) => {
                    setPostTitle(trimLeftSpace(e.target.value));
                  }}
                />
                <div className="create-post-icon-container">
                  <div className="create-post-icon-container">
                    {createAccess === '1' && (
                      <Button
                        className="h-35"
                        btnStyle="primary-dark"
                        text={
                          <>
                            <span>
                              Next
                              <i className="ms-2 bi bi-send" />
                            </span>
                          </>
                        }
                        disabled={!postCategory || !postTitle}
                        onClick={() => {
                          if (!checkEmailVerification(dispatch, navigate, VERIFICATION_STEPS.PROFILE_ONLY)) return;
                          if (postCategory === 8) {
                            setIsQuestion(true);
                          } else {
                            setIsNext(true);
                          }
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>}
      </Card>
    </>
  );
};
export default CreatePost;
